import { JobPosting, WithContext } from "schema-dts";

import {
  BASE_ORGANIZATION_SCHEMA,
  EQUIPMENTSHARE_BASE_URL,
} from "../constants";

import { JobPostingJson } from "./types";

export const buildStructuredData = (
  jobPostingJson: JobPostingJson
): WithContext<JobPosting> => {
  const isRemote =
    jobPostingJson.google.job.customAttributes?.office_names?.stringValues?.some(
      (v) => /^remote/i.test(v)
    );

  const structuredData: WithContext<JobPosting> = {
    "@context": "https://schema.org",
    "@type": "JobPosting",
    title: jobPostingJson.google.job.title,
    description:
      jobPostingJson.google.job.customAttributes.job_description
        ?.stringValues?.[0], // keep html tags
    hiringOrganization: {
      ...BASE_ORGANIZATION_SCHEMA,
      sameAs: EQUIPMENTSHARE_BASE_URL,
      logo: "https://static.estrack.com/logo/1500/0/equipmentshare_logos_2023_hex_gear_light.png",
    },
    url: jobPostingJson.absolute_url,
    datePosted: new Date(
      Number(
        jobPostingJson.google.job.postingUpdateTime?.seconds ||
          jobPostingJson.google.job.postingPublishTime?.seconds
      ) * 1000
    ).toISOString(),
    industry: "Construction",
    employmentType: jobPostingJson.google.job.employmentTypes,
    applicantLocationRequirements: {
      "@type": "Country",
      name: "USA",
    },
  };

  if (jobPostingJson.google.job.addresses?.length) {
    structuredData.jobLocation =
      jobPostingJson.google.job.addresses.length === 1
        ? {
            "@type": "Place",
            address: jobPostingJson.google.job.addresses.at(0),
          }
        : jobPostingJson.google.job.addresses.map((address) => ({
            "@type": "Place",
            address,
          }));
  }

  if (isRemote) {
    structuredData.jobLocationType = "TELECOMMUTE";
  }

  return structuredData;
};
